<template>
  <div class="content_box">
    <div class="content_box_inner">
      <el-row>
        <el-col :xs="24" :lg="5">
          <div class="leftBox">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="企业地图" name="first">
                <el-input
                  class="map_input"
                  size="mini"
                  clearable
                  placeholder="请输入公司名称"
                  suffix-icon="el-icon-search"
                  v-model="inputVal"
                  @change="inputChange"
                ></el-input>
                <el-row>
                  <el-col :span="8">
                    <el-select
                      class="map_select_box"
                      v-model="value1"
                      clearable
                      placeholder="所属区县"
                      @change="SChange1"
                    >
                      <el-option
                        v-for="item in options1"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" style="font-size: 12px">
                    <el-select
                      class="map_select_box"
                      v-model="value2"
                      clearable
                      placeholder="企业性质"
                      @change="SChange2"
                    >
                      <el-option
                        v-for="item in options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-select
                      class="map_select_box"
                      v-model="value3"
                      clearable
                      placeholder="所属行业"
                      @change="SChange3"
                    >
                      <el-option
                        v-for="item in options3"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-select
                      class="map_select_box"
                      v-model="value4"
                      clearable
                      placeholder="是否规上"
                      @change="SChange4"
                    >
                      <el-option
                        v-for="item in options4"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8" style="font-size: 12px">
                    <el-select
                      class="map_select_box"
                      v-model="value5"
                      clearable
                      placeholder="企业规模"
                      @change="SChange5"
                    >
                      <el-option
                        v-for="item in options5"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-select
                      class="map_select_box"
                      v-model="value6"
                      clearable
                      placeholder="企业类别"
                      @change="SChange6"
                    >
                      <el-option
                        v-for="item in options6"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <div style="height: 260px; margin-top: 20px">
                  <div
                    class="company_box"
                    v-for="(item, index) in QYCompanyList"
                    :key="index"
                    @click="showCompany(item.id)"
                  >
                    {{ item.name }}
                  </div>
                </div>

                <el-pagination
                  style="float: right"
                  small
                  @current-change="handleCurrentChange1"
                  :current-page="currentPage1"
                  layout=" prev, pager, next"
                  :total="total11"
                  :hide-on-single-page="page_value1"
                ></el-pagination>
              </el-tab-pane>
              <el-tab-pane label="专题地图" name="second">
                <span>选择专题分类：</span>
                <div style="margin: 10px 0">
                  <el-radio-group
                    v-model="radioVal"
                    size="mini"
                    @change="radioChange"
                  >
                    <el-radio-button label="1">企业类型</el-radio-button>
                    <el-radio-button label="2">行业类别</el-radio-button>
                    <el-radio-button label="3">所属区县</el-radio-button>
                  </el-radio-group>
                </div>
                <span>分类结果：</span>
                <div style="margin: 10px 0">
                  <el-collapse
                    v-model="activeNames"
                    @change="handleChange"
                    accordion
                  >
                    <el-collapse-item
                      :name="item.name"
                      v-for="(item, ind) in ZhuanTiNumList"
                      :key="ind"
                    >
                      <template slot="title" style="font-size: 12px">
                        <i
                          class="header-icon el-icon-location"
                          style="
                            margin-right: 4px;
                            color: #f00;
                            font-size: 16px;
                          "
                        ></i>
                        <span
                          style="
                            display: inline-block;
                            max-weight: 70%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          "
                          :title="item.name"
                          >{{ item.name }}</span
                        >
                        （{{ item.count }}）
                      </template>
                      <div
                        class="company_box"
                        v-for="(item_company, index) in ZhuanTiNumItemList"
                        :key="index"
                        @click="showCompany(item_company.id)"
                      >
                        {{ item_company.name }}
                      </div>
                      <el-pagination
                        style="float: right"
                        small
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        layout=" prev, pager, next"
                        :total="total22"
                        :hide-on-single-page="page_value"
                      ></el-pagination>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :xs="24" :lg="19">
          <div id="mapId"></div>
        </el-col>
      </el-row>

      <el-dialog
        title="企业信息"
        :visible.sync="dialogVisible"
        width="96%"
        :before-close="handleClose"
      >
        <div class="part_2 nowTitle">
          <h3>企业经济情况</h3>
          <el-radio-group
            v-model="timeType"
            style="marginright: 40px; margin-left: 15px"
            align="center"
            @change="typeChange"
          >
            <el-radio label="1">当月</el-radio>
            <el-radio label="0">本年累计</el-radio>
          </el-radio-group>
          <el-date-picker
            v-if="timeType == '1'"
            v-model="nowTime"
            :picker-options="pickerOptions1"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="timeChange"
            type="month"
            placeholder="选择月"
          ></el-date-picker>
          <el-date-picker
            v-if="timeType == '0'"
            v-model="nowTime1"
            :picker-options="pickerOptions1"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="timeChange"
            type="month"
            placeholder="选择累计月份"
          ></el-date-picker>
        </div>
        <div class="nowTitle">
          <h3>{{ companyName }}</h3>
          <span>{{ timeStr }}</span>
        </div>
        <div class="cardsList">
          <div class="card" v-for="(item, index) in cardList" :key="index">
            <div class="num">{{ item.num }}</div>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
        <div class="nowTitle">
          <h3>监测情况</h3>
          <el-radio-group
            v-model="timeType1"
            style="marginright: 40px; margin-left: 15px"
            align="center"
            @change="typeChange1"
          >
            <el-radio label="1">当月</el-radio>
            <el-radio label="0">本年累计</el-radio>
          </el-radio-group>
          <el-date-picker
            v-if="timeType1 == '1'"
            v-model="jcqkTime"
            :picker-options="pickerOptions1"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="timeChange1"
            type="month"
            placeholder="选择月"
          ></el-date-picker>
          <el-date-picker
            v-if="timeType1 == '0'"
            v-model="jcqkTime1"
            :picker-options="pickerOptions1"
            format="yyyy 年"
            value-format="yyyy"
            @change="timeChange1"
            type="year"
            placeholder="选择年"
          ></el-date-picker>
        </div>
        <div class="cutData">
          <div
            :class="['sinBtn', { current: seeBtn.id == item.id }]"
            v-for="item in seeBtnList"
            :key="item.id"
            @click="changeSeeBtn(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="echarts">
          <div id="seeEcharts"></div>
        </div>
        <div class="nowTitle">
          <h3>产品情况</h3>
          <el-radio-group
            v-model="timeType2"
            style="marginright: 40px; margin-left: 15px"
            align="center"
            @change="typeChange2"
          >
            <el-radio label="1">当月</el-radio>
            <el-radio label="0">本年累计</el-radio>
          </el-radio-group>
          <el-date-picker
            v-if="timeType2 == '1'"
            v-model="cpqkTime"
            :picker-options="pickerOptions1"
            format="yyyy 年 MM 月"
            value-format="yyyy-MM"
            @change="timeChange2"
            type="month"
            placeholder="选择月"
          ></el-date-picker>
          <el-date-picker
            v-if="timeType2 == '0'"
            v-model="cpqkTime1"
            :picker-options="pickerOptions1"
            format="yyyy 年"
            value-format="yyyy"
            @change="timeChange2"
            type="year"
            placeholder="选择年"
          ></el-date-picker>
        </div>
        <div class="cutData">
          <div
            :class="['sinBtn', { current: proBtn.code == item.code }]"
            v-for="item in proBtnList"
            :key="item.code"
            @click="changeProBtn(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="echarts">
          <div id="proEcharts"></div>
        </div>
        <hr style="margintop: 40px" />
        <h3>企业情况</h3>
        <div class="Content">
          <!-- <img src="@/assets/imgs/image/compangPic.png" alt /> -->
          <div class="detail">
            <div
              class="itemPart"
              v-for="(item, index) in detailList"
              :key="index"
            >
              <div class="name">{{ item.name }}</div>
              <div class="value">{{ item.value }}</div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import BMap from "BMap";
import { mapGetters } from "vuex";
import { companyIndexSee, companyIndexPro } from "@/utils/echarts_set.js";
export default {
  name: "businessInquiries",
  data() {
    return {
      dialogVisible: false,
      options1: [],
      options2: [
        {
          value: "选项1",
          label: "国有",
        },
        {
          value: "选项2",
          label: "私营",
        },
      ],
      options3: [],
      options4: [
        {
          value: "选项1",
          label: "是",
        },
        {
          value: "选项2",
          label: "否",
        },
      ],
      options5: [
        {
          value: "选项1",
          label: "大型",
        },
        {
          value: "选项2",
          label: "中型",
        },
        {
          value: "选项3",
          label: "小型",
        },
        {
          value: "选项4",
          label: "微型",
        },
      ],
      options6: [
        {
          value: "选项1",
          label: "50户重点",
        },
        {
          value: "选项2",
          label: "小巨人",
        },
        {
          value: "选项3",
          label: "专精特新",
        },
        {
          value: "选项4",
          label: "隐形冠军",
        },
      ],
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      inputVal: "",
      QYCompanyList: [],
      activeName: "first",
      activeNames: "",
      radioVal: 1,
      ZhuanTiNumList: [],
      ZhuanTiNumItemList: [],
      currentPage: 1,
      total22: 20,
      page_value: false,
      page: 1,
      currentPage1: 1,
      total11: 20,
      page_value1: false,
      page1: 1,
      company_name: "",
      ms: [],
      listname: [""],
      companyName: "",
      timeStr: "",
      total: "",
      total1: "",
      notLoadList: [],
      notReList: [],
      cardList: [],
      seeBtnList: [
        { name: "工业总产值", id: 0 },
        { name: "工业销售产值", id: 1 },
        { name: "企业用电量", id: 2 },
        { name: "主营业务收入", id: 3 },
        { name: "税收", id: 4 },
        { name: "利润总额", id: 5 },
        { name: "存货", id: 6 },
        { name: "贷款余额", id: 7 },
      ],
      detailList: [],
      proBtnList: [],
      seeBtn: { name: "工业总产值", id: 0 },
      proBtn: {},
      jcqk: "",
      cpqk: "",
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      timeType: "1",
      timeType1: "1",
      timeType2: "1",
      nowTime: "",
      nowTime1: "",
      jcqkTime: "",
      jcqkTime1: "",
      cpqkTime: "",
      cpqkTIme1: "",
      timeString: "",
      timeString1: "",
      timeString2: "",
      ID: "04f453c57f2249cb9c74e439f4dc0ab5",
    };
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
      seatList1: "getAreaListArr",
    }),
  },

  created() {
    this.listname = this.seatList1;
    this.options1 = this.seatList;
  },

  mounted() {
    this.getZhuanTiNum();
    this.getIndustryList();
    this.getQYCompanyList();
    this.getAllCompany();
    this.setTime();
    this.typeChange("0");
    // this.getNotLoadList(0, 0);
    // this.getNotUpdatedList(1, 0);
  },

  methods: {
    handleClose(done) {
      done();
      // this.$confirm("确认关闭？")
      //   .then((_) => {
      //     done();
      //   })
      //   .catch((_) => {});
    },
    showCompany(id) {
      this.dialogVisible = true;
      this.ID = id;
      this.myCompany(id);
      this.initPro(id);
    },
    //获取所有公司的名字、地址信息
    getAllCompany() {
      this.$axios
        .get(`/business/upgrade/map/selectAllCompanyAddress`)
        .then((res) => {
          this.ms = res.data.data;
          this.getMap();
        });
    },

    SChange1() {
      this.getQYCompanyList();
    },
    SChange2() {
      this.getQYCompanyList();
    },
    SChange3() {
      this.getQYCompanyList();
    },
    SChange4() {
      this.getQYCompanyList();
    },
    SChange5() {
      this.getQYCompanyList();
    },
    SChange6() {
      this.getQYCompanyList();
    },
    inputChange() {
      this.getQYCompanyList();
    },
    getQYCompanyList() {
      this.$axios
        .get(
          `/business/upgrade/map/searchMapCompany?name=${this.inputVal}&district=${this.value1}&companyNature=${this.value2}&industry=${this.value3}&aboveScale=${this.value4}&companySize=${this.value5}&companyCategory=${this.value6}&pageNum=${this.page1}&pageSize=10`
        )
        .then((res) => {
          // this.options3 = res.data.data;
          this.total11 = res.data.data.total;
          if (this.total11 <= 10) {
            this.page_value1 = true;
          }
          this.QYCompanyList = res.data.data.list;
        });
      this.$axios
        .get(
          `/business/upgrade/map/searchMapCompany?name=${this.inputVal}&district=${this.value1}&companyNature=${this.value2}&industry=${this.value3}&aboveScale=${this.value4}&companySize=${this.value5}&companyCategory=${this.value6}&pageNum=${this.page1}&pageSize=1000`
        )
        .then((res) => {
          this.ms = res.data.data.list;
          this.getMap();
        });
    },
    //获取行业类型
    getIndustryList() {
      this.$axios
        .get(`/business/upgrade/risk/selectIndustryType`)
        .then((res) => {
          this.options3 = res.data.data;
        });
    },
    radioChange(val) {
      this.radioVal = val;
      this.getZhuanTiNum();
      this.getCompanyNum();
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCompanyNum();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
    },
    handleCurrentChange1(val) {
      this.page1 = val;
      this.getQYCompanyList();
    },
    getZhuanTiNum() {
      this.$axios
        .get(`/business/upgrade/map/searchMapTopic?type=${this.radioVal}`)
        .then((res) => {
          this.ZhuanTiNumList = res.data.data;
        });
    },
    handleClick(tab, event) {},
    handleChange(val) {
      this.company_name = val;
      this.getCompanyNum();
    },
    getCompanyNum() {
      this.$axios
        .get(
          `/business/upgrade/map/searchMapTopicByTypeName?type=${this.radioVal}&name=${this.company_name}&pageNum=${this.page}&pageSize=10`
        )
        .then((res) => {
          this.total22 = res.data.data.total;
          if (this.total22 <= 10) {
            this.page_value = true;
          }
          this.ZhuanTiNumItemList = res.data.data.list;
        });
      this.$axios
        .get(
          `/business/upgrade/map/searchMapTopicByTypeName?type=${this.radioVal}&name=${this.company_name}&pageNum=${this.page}&pageSize=1000`
        )
        .then((res) => {
          this.ms = res.data.data.list;
          this.getMap();
        });
    },

    getMap() {
      var map = new BMap.Map("mapId"); // 创建Map实例
      //设置地图类型
      map.setMapType(BMAP_HYBRID_MAP);
      // 创建Map实例
      map.centerAndZoom(this.seatList1[0], 8); // 初始化地图,设置中心点坐标和地图级别
      // map.centerAndZoom(new BMap.Point(112.45, 34.62), 10); // 初始化地图,设置中心点坐标和地图级别
      //添加地图类型控件
      // map.addControl(
      //   new BMap.MapTypeControl({
      //     mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP],
      //   })
      // );
      map.setCurrentCity(this.seatList1[0]);
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      // map.clearOverlays(); //清除地图覆盖物
      map.addEventListener("zoomend", function (e) {
        let z = map.getZoom();
        if (z > 9) {
          map.setMapType(BMAP_SATELLITE_MAP);
        } else {
          map.setMapType(BMAP_HYBRID_MAP);
        }
      });
      var listname = this.listname;
      console.log(listname);
      // for (let i = 0; i < listname.length; i++) {
      //   this.getBoundary(map, listname[i].name);
      // }
      for (let i = 0; i < listname.length; i++) {
        this.getBoundary(map, listname[i]);
      }
      this.addAnnotation(this.ms, map);

      // this.getBoundary(map, this.seatList1[0]);
    },

    //添加标注点
    addAnnotation(ms, map) {
      ms.forEach((item) => {
        this.addMarker(item, map);
      });
    },

    addMarker(item, map) {
      var _this = this;
      let myGeo = new BMap.Geocoder();
      myGeo.getPoint(item.officeAddress, function (point) {
        if (point) {
          map.centerAndZoom(point, 9);
          let marker = new BMap.Marker(point);
          let myIcon = new BMap.Icon(
            require("../../assets/img/barbg1.png"),
            new BMap.Size(30, 30)
          );
          marker.setIcon(myIcon);
          map.addOverlay(marker);
          var pit = new BMap.Point(point.lng, point.lat);
          var opts = {
            position: pit, // 指定文本标注所在的地理位置
            offset: new BMap.Size(12, -14), //设置文本偏移量
          };
          var label = new BMap.Label(item.name, opts); // 创建文本标注对象
          label.setStyle({
            color: "red",
            fontSize: "12px",
            borderColor: "#000",
            height: "20px",
            lineHeight: "20px",
            padding: "4px",
            fontFamily: "微软雅黑",
          });
          map.addOverlay(label);
          marker.addEventListener("click", function (e) {
            map.centerAndZoom(e.point, 16);
          });

          label.addEventListener("click", function (e) {
            _this.showCompany(item.id);
          });
        }
      });
    },

    getBoundary(map, name) {
      var bdary = new BMap.Boundary();
      bdary.get(name, function (rs) {
        //获取行政区域
        // map.clearOverlays(); //清除地图覆盖物
        var count = rs.boundaries.length; //行政区域的点有多少个
        if (count === 0) {
          return;
        }
        var pointArray = [];
        for (var i = 0; i < count; i++) {
          var ply = new BMap.Polygon(rs.boundaries[i], {
            fillColor: "",
            strokeWeight: 4,
            strokeColor: "#ff0000",
            strokeOpacity: 0.8,
          }); //建立多边形覆盖物
          ply.setFillColor("none");
          ply.disableMassClear();
          map.addOverlay(ply); //添加覆盖物
          pointArray = pointArray.concat(ply.getPath());
        }
        // map.setViewport(pointArray); //调整视野
      });
    },
    /**** */
    initPro(id) {
      this.$axios
        .get(`/business/upgrade/map/selectProByCode?id=${id}`)
        .then((res) => {
          this.proBtnList = res.data.data;
          this.proBtn = res.data.data[0];
          this.creatEcharts();
        });
    },

    jumpNotRelist() {
      // alert(1);
      this.$router.push("/index/workbench/dataWrite?activeName=edit");
    },
    jumpNotLoadList() {
      this.$router.push("/index/workbench/dataWrite");
    },
    typeChange: function (val) {
      let that = this;
      that.timeType = val;
      if (val == "0") {
        var data = new Date();
        var month =
          data.getMonth() < 9
            ? "0" + (data.getMonth() + 1)
            : data.getMonth() + 1;
        var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
        var time = data.getFullYear() + "-" + month;
        that.nowTime1 = data;
        that.timeChange(time);
      } else if (val == "1") {
        var data1 = new Date();
        var month1 =
          data1.getMonth() < 9
            ? "0" + (data1.getMonth() + 1)
            : data1.getMonth() + 1;
        var date1 =
          data1.getDate() <= 9 ? "0" + data1.getDate() : data1.getDate();
        var time1 = data1.getFullYear() + "-" + month1;
        that.nowTime = data1;
        that.timeChange(time1);
      }
    },
    typeChange1: function (val) {
      let that = this;
      that.timeType1 = val;
      if (val == "0") {
        var data = new Date();
        var month =
          data.getMonth() < 9
            ? "0" + (data.getMonth() + 1)
            : data.getMonth() + 1;
        var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
        var time = data.getFullYear();
        that.jcqkTime1 = data;
        that.timeChange1(time);
      } else if (val == "1") {
        var data1 = new Date();
        var month1 =
          data1.getMonth() < 9
            ? "0" + (data1.getMonth() + 1)
            : data1.getMonth() + 1;
        var date1 =
          data1.getDate() <= 9 ? "0" + data1.getDate() : data1.getDate();
        var time1 = data1.getFullYear() + "-" + month1;
        that.jcqkTime = data1;
        that.timeChange1(time1);
      }
    },
    typeChange2: function (val) {
      let that = this;
      that.timeType2 = val;

      if (val == "0") {
        var data = new Date();
        var month =
          data.getMonth() < 9
            ? "0" + (data.getMonth() + 1)
            : data.getMonth() + 1;
        var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
        var time = data.getFullYear();
        that.cpqkTime1 = data;
        that.timeChange2(time);
      } else if (val == "1") {
        var data1 = new Date();
        var month1 =
          data1.getMonth() < 9
            ? "0" + (data1.getMonth() + 1)
            : data1.getMonth() + 1;
        var date1 =
          data1.getDate() <= 9 ? "0" + data1.getDate() : data1.getDate();
        var time1 = data1.getFullYear() + "-" + month1;
        that.cpqkTime = data1;
        that.timeChange2(time1);
      }
      //      var tb2=   {name:   "铁矿石原矿",id:0} ;
      //      this.changeProBtn(tb2);
    },
    setTime() {
      var data = new Date();
      var month =
        data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var year = data.getFullYear();
      this.nowTime1 = data; //year;
      this.nowTime = data; //year+"-"+month;
      this.jcqkTime = data;
      this.jcqkTime1 = data;
      this.cpqkTime = data;
      this.cpqkTime1 = data;
      var time = year + "-" + month;
      this.timeString1 = time;
      this.timeString2 = time;
      this.timeChange(time);
    },
    timeChange1(val) {
      var type = this.timeType1;
      var timeCompare = "";
      if (typeof val !== "string") {
        timeCompare = val.toString();
      } else timeCompare = val;
      this.timeString1 = timeCompare;
      var bt1 = this.seeBtn;
      this.changeSeeBtn(bt1);
    },
    timeChange2(val) {
      var type = this.timeType2;

      var timeCompare = "";

      if (typeof val !== "string") {
        timeCompare = val.toString();
      } else timeCompare = val;

      this.timeString2 = timeCompare;
      var tb2 = this.proBtn;
      this.changeProBtn(tb2);
    },
    timeChange(val) {
      var type = this.timeType;
      var time = "";
      var nameStr = "";
      var data = new Date();
      var yearNow = data.getFullYear();
      var timeCompare = "";

      if (typeof val !== "string") {
        timeCompare = val.toString();
      } else timeCompare = val;
      //.log(timeCompare);
      var timeArray = timeCompare.split("-");

      var month = data.getMonth() + 1;

      if (type == "0") {
        if (parseInt(timeArray[1]) == 1) {
          time = "1月";
        } else time = "1-" + parseInt(timeArray[1]) + "月";
      } else if (type == "1") {
        time = parseInt(timeArray[1]) + "月";
      }
      this.timeString = timeCompare;
      this.timeStr = time;

      this.$axios
        .get(
          "/business/upgrade/map/selectPercent?type=" +
            type +
            "&time=" +
            val +
            "&id=" +
            this.ID
        )
        .then((res) => {
          var card = [];

          var obj = {
            num: res.data.data.value1.toFixed(2),
            label: time + "总产值(万元)",
          };

          var obj2 = {
            label: "占本市全行业（大类）比",
            num: res.data.data.value3,
          };

          var obj4 = {
            label: "占本市总产值比",
            num: res.data.data.value5,
          };

          var obj6 = {
            label: "占本区（县）总产值比",
            num: res.data.data.value7,
          };

          if (type == "0") {
            card.push(obj);
            card.push(obj2);
            card.push(obj4);
            card.push(obj6);
          } else if (type == "1") {
            card.push(obj);
            card.push(obj2);
            card.push(obj4);
            card.push(obj6);
          }
          this.cardList = card;
        });
    },
    changeSeeBtn(now) {
      this.seeBtn = now;
      var dataArray = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      var timeArray = [];
      var type = this.timeType1;
      if (type == "0") {
        timeArray = [
          "1月",
          "1-2月",
          "1-3月",
          "1-4月",
          "1-5月",
          "1-6月",
          "1-7月",
          "1-8月",
          "1-9月",
          "1-10月",
          "1-11月",
          "1-12月",
        ];
      } else if (type == "1") {
        timeArray = [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ];
      }

      var speedArray = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      this.seeBtn = now;
      this.jcqk = now.name;
      var time = this.timeString1; //data.getFullYear();
      this.$axios
        .get(
          "/business/upgrade/map/selectCondition?time=" +
            time +
            "&type=" +
            type +
            "&id=" +
            this.ID
        )
        .then((res) => {
          var dataObj = [];
          if (now.id == 0) {
            dataObj = res.data.data.gyzcz;
            for (var i = 0; i < dataArray.length; i++) {
              for (var j = 0; j < dataObj.length; j++) {
                if (dataObj[j].monthQuery == i + 1) {
                  dataArray[i] = dataObj[j].monthThis1.toFixed(2);
                  speedArray[i] = dataObj[j].monthThis.toFixed(1);
                }
              }
            }
          }
          if (now.id == 1) {
            dataObj = res.data.data.gyxscz;
            for (var i1 = 0; i1 < dataArray.length; i1++) {
              for (var j1 = 0; j1 < dataObj.length; j1++) {
                if (dataObj[j1].monthQuery == i1 + 1) {
                  dataArray[i1] = dataObj[j1].monthThis1.toFixed(2);
                  speedArray[i1] = dataObj[j1].monthThis.toFixed(1);
                }
              }
            }
          }
          if (now.id == 2) {
            dataObj = res.data.data.qyydl;
            for (var i2 = 0; i2 < dataArray.length; i2++) {
              for (var j2 = 0; j2 < dataObj.length; j2++) {
                if (dataObj[j2].monthQuery == i2 + 1) {
                  dataArray[i2] = dataObj[j2].monthThis1.toFixed(2);
                  speedArray[i2] = dataObj[j2].monthThis.toFixed(1);
                }
              }
            }
          }
          if (now.id == 3) {
            dataObj = res.data.data.zyywsr;
            for (var i3 = 0; i3 < dataArray.length; i3++) {
              for (var j3 = 0; j3 < dataObj.length; j3++) {
                if (dataObj[j3].monthQuery == i3 + 1) {
                  dataArray[i3] = dataObj[j3].thisMonth.toFixed(2);
                  speedArray[i3] = parseFloat(dataObj[j3].code).toFixed(1);
                }
              }
            }
          }
          if (now.id == 4) {
            dataObj = res.data.data.sj;
            for (var i4 = 0; i4 < dataArray.length; i4++) {
              for (var j4 = 0; j4 < dataObj.length; j4++) {
                if (dataObj[j4].monthQuery == i4 + 1) {
                  dataArray[i4] = dataObj[j4].thisMonth.toFixed(2);
                  speedArray[i4] = parseFloat(dataObj[j4].code).toFixed(1);
                }
              }
            }
          }
          if (now.id == 5) {
            dataObj = res.data.data.lrze;
            for (var i5 = 0; i5 < dataArray.length; i5++) {
              for (var j5 = 0; j5 < dataObj.length; j5++) {
                if (dataObj[j5].monthQuery == i5 + 1) {
                  dataArray[i5] = dataObj[j5].thisMonth.toFixed(2);
                  speedArray[i5] = parseFloat(dataObj[j5].code).toFixed(1);
                }
              }
            }
          }
          if (now.id == 6) {
            dataObj = res.data.data.ch;
            for (var i6 = 0; i6 < dataArray.length; i6++) {
              for (var j6 = 0; j6 < dataObj.length; j6++) {
                if (dataObj[j6].monthQuery == i6 + 1) {
                  dataArray[i6] = dataObj[j6].thisMonth.toFixed(2);
                  speedArray[i6] = parseFloat(dataObj[j6].code).toFixed(1);
                }
              }
            }
          }
          if (now.id == 7) {
            dataObj = res.data.data.dkye;
            for (var i7 = 0; i7 < dataArray.length; i7++) {
              for (var j7 = 0; j7 < dataObj.length; j7++) {
                if (dataObj[j7].monthQuery == i7 + 1) {
                  dataArray[i7] = dataObj[j7].thisMonth.toFixed(2);
                  speedArray[i7] = parseFloat(dataObj[j7].code).toFixed(1);
                }
              }
            }
          }
          var minInNumbers = Math.min.apply(Math, speedArray);
          var maxInNumbers = Math.max.apply(Math, dataArray);
          var max = 0;
          var min = 0;
          if (maxInNumbers > 250) max = maxInNumbers + 100;
          else max = 250;
          max = Math.ceil(max);
          if (minInNumbers < 0) min = -100;
          else min = 0;
          var gird = Math.ceil(max / 10);
          let _this = this;
          //监测情况
          var seeEcharts = _this.$echarts.init(
            document.getElementById("seeEcharts")
          );
          var legendData = [];
          if (type == "0") {
            legendData = ["本年累计", "同比增速"];
          } else if (type == "1") {
            legendData = ["本月", "同比增速"];
          }
          seeEcharts.setOption(
            companyIndexSee({
              xAxis: timeArray,
              currentYear: dataArray,
              speed: speedArray,
              legend: legendData,
              min: min,
              max: max,
              gird: gird,
              title: this.jcqk,
            })
          );
        });
    },
    changeProBtn(now) {
      this.proBtn = now;
      this.cpqk = now.name;
      var code = now.code;
      var timeArray = [];
      var type = this.timeType2;
      if (type == "0") {
        timeArray = [
          "1月",
          "1-2月",
          "1-3月",
          "1-4月",
          "1-5月",
          "1-6月",
          "1-7月",
          "1-8月",
          "1-9月",
          "1-10月",
          "1-11月",
          "1-12月",
        ];
      } else if (type == "1") {
        timeArray = [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ];
      }
      var thisData = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      var thatData = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      var speedData = [
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
        0.0,
      ];
      //var data = new Date();
      //var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      //var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var time = this.timeString2; //data.getFullYear();data.getFullYear();
      this.$axios
        .get(
          "/business/upgrade/map/selectProduct?time=" +
            time +
            "&type=" +
            type +
            "&code=" +
            code +
            "&id=" +
            this.ID
        )
        .then((res) => {
          var dataObj = [];
          dataObj = res.data.data;
          for (var m = 0; m < thisData.length; m++) {
            for (var n = 0; n < dataObj.length; n++) {
              if (dataObj[n].monthQuery == m + 1) {
                thisData[m] = dataObj[n].monthLast.toFixed(2);
                thatData[m] = dataObj[n].monthThis.toFixed(2);
                speedData[m] = dataObj[n].monthThis1.toFixed(1);
              }
            }
          }
          if (now.id == 0) {
            dataObj = res.data.data.tksyk;
            for (var i = 0; i < thisData.length; i++) {
              for (var j = 0; j < dataObj.length; j++) {
                if (dataObj[j].monthQuery == i) {
                  thisData[i] = dataObj[j].monthLast;
                  thatData[i] = dataObj[j].monthThis;
                  speedData[i] = dataObj[j].monthThis1;
                }
              }
            }
          }
          if (now.id == 1) {
            dataObj = res.data.data.tkscpk;
            for (var i1 = 0; i1 < thisData.length; i1++) {
              for (var j1 = 0; j1 < dataObj.length; j1++) {
                if (dataObj[j1].monthQuery == i1) {
                  thisData[i1] = dataObj[j1].monthLast;
                  thatData[i1] = dataObj[j1].monthThis;
                  speedData[i1] = dataObj[j1].monthThis1;
                }
              }
            }
          }
          if (now.id == 2) {
            dataObj = res.data.data.tmsyk;
            for (var i2 = 0; i2 < thisData.length; i2++) {
              for (var j2 = 0; j2 < dataObj.length; j2++) {
                if (dataObj[j2].monthQuery == i2) {
                  thisData[i2] = dataObj[j2].monthLast;
                  thatData[i2] = dataObj[j2].monthThis;
                  speedData[i2] = dataObj[j2].monthThis1;
                }
              }
            }
          }

          var minInNumbers = Math.min.apply(Math, speedData);
          var maxInNumbers = Math.max.apply(Math, thatData);
          var maxInNumbers1 = Math.max.apply(Math, thisData);
          var max = 0;
          var min = 0;
          var maxData =
            maxInNumbers > maxInNumbers1 ? maxInNumbers : maxInNumbers1;
          if (maxData > 250) max = maxData + 100;
          else max = 250;
          max = Math.ceil(max);
          if (minInNumbers < 0) min = -100;
          else min = 0;

          var gird = Math.ceil(max / 10);
          //产品情况
          let _this = this;
          var legendData = [];
          if (type == "0") {
            legendData = ["去年累计", "本年累计", "同比增速"];
          } else if (type == "1") {
            legendData = ["去年本月", "本月", "同比增速"];
          }
          var proEcharts = _this.$echarts.init(
            document.getElementById("proEcharts")
          );
          proEcharts.setOption(
            companyIndexPro({
              xAxis: timeArray,
              companyIndexPro: thisData,
              currentYearSall: thatData,
              proSpeed: speedData,
              legend: legendData,
              min: min,
              max: max,
              gird: gird,
              title: this.cpqk + "产品情况",
            })
          );
        });
    },
    creatEcharts() {
      var bt1 = { name: "工业总产值", id: 0 };
      if (this.proBtnList.length == 0) {
        var timeArray = [];
        var type = this.timeType2;
        if (type == "0") {
          timeArray = [
            "1月",
            "1-2月",
            "1-3月",
            "1-4月",
            "1-5月",
            "1-6月",
            "1-7月",
            "1-8月",
            "1-9月",
            "1-10月",
            "1-11月",
            "1-12月",
          ];
        } else if (type == "1") {
          timeArray = [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ];
        }
        var thisData = [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
        ];
        var thatData = [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
        ];
        var speedData = [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
        ];
        var legendData = [];
        if (type == "0") {
          legendData = ["去年累计", "本年累计", "同比增速"];
        } else if (type == "1") {
          legendData = ["去年本月", "本月", "同比增速"];
        }
        var proEcharts = this.$echarts.init(
          document.getElementById("proEcharts")
        );
        proEcharts.setOption(
          companyIndexPro({
            xAxis: timeArray,
            companyIndexPro: thisData,
            currentYearSall: thatData,
            proSpeed: speedData,
            legend: legendData,
            min: 0,
            max: 100,
            gird: 10,
            title: "",
          })
        );
      } else {
        var tb2 = this.proBtnList[0];
        this.changeProBtn(tb2);
      }
      this.changeSeeBtn(bt1);
    },
    myCompany(id) {
      let _this = this;
      var array = [];
      _this.$axios
        .get(`/business/upgrade/map/selectByCode?id=${id}`)
        .then((res) => {
          var company = res.data.data;
          _this.companyName = company.name;
          var name = {
            name: "企业标准名称",
            code: "",
            value: company.name,
          };
          array.push(name);
          var address = {
            name: "企业办公地址",
            code: "",
            value: company.officeAddress,
          };
          array.push(address);
          var code = {
            name: "统一社会信用代码",
            code: "",
            value: company.code,
          };
          array.push(code);

          var zzjgCode = company.code;
          var subCode = "";
          if (zzjgCode.length > 9) {
            subCode = zzjgCode.substr(zzjgCode.length - 9, 9);
            //alert(zzjgCode.substr(zzjgCode.length-9, 9));
          } else {
            subCode = "";
          }

          var code1 = {
            name: "组织机构代码",
            code: "",
            value: subCode,
          };
          array.push(code1);
          var location = {
            name: "所在区（市）县",
            code: "",
            value: company.district,
          };
          array.push(location);
          var park = {
            name: "所属园区",
            code: "",
            value: company.park,
          };
          array.push(park);
          //                                         var  code2=   {
          //                                               name: "国民经济行业代码",
          //                                               code: "",
          //                                               value: company.industryType
          //                                             };array.push(code2);
          var type = {
            name: "国民经济行业分类",
            code: "",
            value: company.industryType,
          };
          array.push(type);
          var name1 = {
            name: "法人姓名",
            code: "",
            value: company.representativePerson,
          };
          array.push(name1);
          var name2 = {
            name: "联系人姓名",
            code: "",
            value: company.contactName,
          };
          array.push(name2);
          var contactPhone = {
            name: "联系人手机号码",
            code: "",
            value: company.contactPhone,
          };
          array.push(contactPhone);

          var konggu = {
            name: "企业控股情况",
            code: "",
            value: company.companyProfile,
          }; //array.push(konggu);
          var registerAddress = {
            name: "企业注册地址",
            code: "",
            value: company.registerAddress,
          };
          array.push(registerAddress);
          var registerType = {
            name: "企业登记注册类型",
            code: "",
            value: company.registerType,
          };
          array.push(registerType);
          _this.detailList = array;
        });
    },
  },
};
</script>

<style>
.leftBox .el-input__inner {
  height: 26px;
  line-height: 26px;
  padding: 0 8px;
}

.leftBox .el-input {
  font-size: 12px;
}

.leftBox .el-input__icon {
  width: 14px;
  line-height: 100%;
}
</style>

<style lang="less" scoped>
.leftBox {
  padding-right: 10px;
  padding-bottom: 20px;
  height: 680px;
  overflow-y: auto;
}
#mapId {
  width: 100%;
  height: 680px;
}

#selectId .el-input {
  font-size: 12px !important;
}

.company_box {
  padding: 4px 10px;
}

.company_box:hover {
  cursor: pointer;
  color: #5584ff;
}

hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 40px;
}

.tableList {
  display: flex;
  justify-content: space-between;

  .half {
    width: 48%;
  }
}

.part_2 {
  display: flex;
  align-items: center;

  .lineTitle {
    margin-right: 40px;
    line-height: 52px;
  }

  .lineTitle::before {
    top: 15px;
    color: #5584ff;
  }
}

.nowTitle {
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-bottom: 10px;
  margin-top: 50px;

  span {
    font-size: 18px;
    color: rgba(68, 68, 68, 1);
    margin-left: 30px;
    margin-top: 3px;
  }
}

.cardsList {
  display: flex;
  padding-left: 20px;
  justify-content: space-between;
  width: auto;

  .card {
    width: 180px;
    height: 130px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-top: 8px solid rgba(62, 113, 247, 1);
    border-radius: 2px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .num {
      font-size: 30px;
      color: rgba(85, 132, 255, 1);
      margin-bottom: 5px;
    }

    .label {
      font-size: 14px;
      color: rgba(68, 68, 68, 1);
    }
  }
}

.cutData {
  display: flex;
  box-sizing: border-box;
  width: auto;
  padding-left: 20px;

  .sinBtn {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 0;
    box-sizing: border-box;
    width: 120px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .sinBtn:last-child {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }

  .sinBtn.current {
    background-color: rgba(62, 113, 247, 1);
    color: #ffffff;
  }
}

.echarts {
  margin-top: 30px;
  margin-left: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  height: 470px;
  display: flex;
  align-items: center;
  justify-content: center;

  #seeEcharts {
    width: 1500px;
    height: 450px;
  }

  #proEcharts {
    width: 1500px;
    height: 450px;
  }
}

.jumPage:hover {
  cursor: pointer;
}

.Content {
  display: flex;

  img {
    width: 530px;
    height: 360px;
  }

  .detail {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;

    .itemPart {
      width: 180px;
      height: 100px;
      box-sizing: border-box;
      display: left;
      flex-direction: column;
      justify-content: center;
      padding-left: 20px;

      .name {
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 10px;
      }

      .value {
        font-size: 16px;
        font-weight: 700;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  height: 700px;
  padding: 10px 10px 10px;
  box-shadow: 0px 0px 50px #ccc;
}
.pagePhone {
  display: none;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    height: auto;
    padding: 10px 10px 20px;
  }
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
  .leftBox {
    padding-right: 0px;
    padding-bottom: 20px;
    height: auto;
  }
}
</style>